export default "__VITE_ASSET__B8Wie_Km__"